import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Button,
  Dialog,
  Grid2,
  Autocomplete,
  TextField,
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import AddPublicHoliday from "../../components/PublicHoliday/AddPublicHoliday";
import { useNavigate, useLocation } from "react-router-dom";
import {
  deletePublicHoliday,
  getPublicHoliday,
} from "../../services/publicHoliday.service";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import moment from "moment";
import MasterCommonTable from "../../sharedComponents/MaterCommonTable/MasterCommonTable";
import { ToastError } from "../../utils/Toaster/Toaster";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import { jwtDecode } from "jwt-decode";
import { encryptData } from "../../utils/cryptoUtils";
import { useAuth } from "../../context/AuthProvider";
import PermissionGate from "../../components/Permission/PermissionGate";
import { usePermissions } from "../../context/PermissionProvider";
import { isAdminRole } from "../../utils/roles";

const PublicHoliday = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [data, setData] = useState([]);
  const { accessToken } = useAuth();
  const { canAdd, canEdit, canDelete } = usePermissions();
  const [selectedData, setSelectedData] = useState({});
  const [tableTotalCount, setTableCount] = useState(0);
  const [who, setIsWho] = useState(false);
  const [queryParam, setQueryParam] = useState({
    year: moment().format("YYYY"),
    type: "All",
  });
  const currentYear = dayjs().year();
  const minYear = currentYear - 9;
  const maxYear = currentYear + 10;

  const navigate = useNavigate();
  const location = useLocation();
  const fromDashboard = location.state?.fromDashboard;

  const getPublicHolidayData = async () => {
    try {
      const encryptedYear = encryptData(queryParam.year);
      const encryptedType = encryptData(queryParam.type);
      const res = await getPublicHoliday({
        year: encryptedYear,
        type: encryptedType,
      });
      const modifiedData = res.data.data.map((e) => {
        return {
          ...e,
          eventDate: moment(e?.date).format("DD/MM/YYYY"),
        };
      });
      setData(modifiedData);
      setTableCount(res?.data?.totalCount || 0);
    } catch (error) {
      console.log(error);
    }
  };

  //const who = JSON.parse(localStorage.getItem("isOverAllAdmin"));

  useEffect(() => {
    // const token = localStorage.getItem("token");
    if (accessToken) {
      try {
        const decodedToken = jwtDecode(accessToken);
        setIsWho(isAdminRole(decodedToken.role));
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);
  console.log("Current Role (who):", who);

  useEffect(() => {
    getPublicHolidayData();
  }, [queryParam.year, queryParam.type]);

  const handleAdd = () => {
    setOpenDrawer(true);
    setSelectedData({});
  };

  const HolidayType = [
    { label: "All", name: "All" },
    { label: "Completed", name: "Completed" },
    { label: "UpComing", name: "Upcoming" },
  ];

  const handleView = (e) => {
    e.isView = true;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const handleEdit = (e) => {
    e.isView = false;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const handleDelete = async (e) => {
    try {
      const res = await deletePublicHoliday(e._id);
      getPublicHolidayData();
      ToastError(res.message);
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    { id: "name", label: "Name" },
    { id: "eventDate", label: "Event Date" },
    { id: "description", label: "Description" },
  ];

  const tableConfig = {
    isMore: true,
    isAction: who === true ? true : false,
    isAdmin: true,
    isView: true,
    isEdit: canEdit("publicHoliday"),
    isDelete: canDelete("publicHoliday"),
  };

  return (
    <div className="mainPageRenderingContainer">
      <Box sx={{ height: "fit-content" }}>
        <Grid container spacing={2} sx={{ justifyContent: "space-between" }}>
          <Grid item xs={12} sm={3} />
          <Grid item xs={12} sm={2} />
          {who === false ? (
            <Grid item xs={12} sm={2.5} />
          ) : (
            <Grid item xs={12} sm={0.5} />
          )}
          <Grid item xs={12} sm={2.5}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker", "DatePicker"]}>
                <DatePicker
                  views={["year"]}
                  openTo="month"
                  value={dayjs(queryParam.year)}
                  className="datePicker w-100"
                  minDate={dayjs().year(minYear)} // Setting the minimum allowed year
                  maxDate={dayjs().year(maxYear)}
                  onChange={(e) => {
                    setQueryParam({
                      ...queryParam,
                      year: moment(e?.$d).format("YYYY"),
                    });
                  }}
                  slots={{
                    openPickerIcon: CalendarTodayRoundedIcon,
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={1.5}>
            <Autocomplete
              options={HolidayType}
              disableClearable={true}
              value={
                HolidayType.find((option) => option.name === queryParam.type) ||
                null
              }
              className="w-100"
              onChange={(e, v) => {
                setQueryParam({
                  ...queryParam,
                  type: v ? v.name : queryParam.type,
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Status"
                  className="AutoComplete_InputBox"
                  focused={false}
                />
              )}
            />
          </Grid>
          {who === false ? (
            <Grid item xs={12} sm={2.5} />
          ) : (
            <Grid item xs={12} sm={2}>
              <PermissionGate module="publicHoliday" action="add">
                <Button
                  startIcon={<AddOutlinedIcon />}
                  onClick={() => handleAdd()}
                  className="Add-Button w-100"
                >
                  Add Public Holiday
                </Button>
              </PermissionGate>
            </Grid>
          )}

          {/* <Grid item xs={12} sm={3}>
          <Button
            startIcon={<AddOutlinedIcon />}
            onClick={() => handleAddEmployee()}
            className="Add-Button w-100"
          >
            Add Employee
          </Button>
        </Grid> */}
        </Grid>
      </Box>
      <MasterCommonTable
        tableConfig={tableConfig}
        data={data}
        columns={columns}
        handleEdit={handleEdit}
        handleView={handleView}
        handleDelete={handleDelete}
        tableTotalCount={tableTotalCount}
      />
      {fromDashboard && (
        <Button
          onClick={() => navigate("/home/dashboard")}
          className="Close-Button"
        >
          Close
        </Button>
      )}
      <Dialog
        open={openDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="sm"
      >
        {openDrawer ? (
          <AddPublicHoliday
            selectedData={selectedData}
            setOpenDrawer={setOpenDrawer}
            formType={
              selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
            }
            GetData={getPublicHolidayData}
          />
        ) : null}
      </Dialog>
    </div>
  );
};

export default PublicHoliday;
